import React, { useRef, useState, Suspense } from "react";
import { Canvas } from "@react-three/fiber";
import { PerspectiveCamera, ScrollControls } from "@react-three/drei";
import * as THREE from "three";
import ParticleText from "../components/ParticleText";
import ProjectsScene from "../components/projects/ProjectsScene";
import UnifiedScrollHandler from "../components/scroll/UnifiedScrollHandler";
import HTMLSections from "../components/HTMLSections";
import { CurrentTileProvider } from "../contexts/CurrentTileContext";
import ProjectOverlay from "../components/projects/ProjectOverlay";

const Unified = () => {
  const particleTextRef = useRef(null);

  // Always start at home scene
  const [currentScene, setCurrentScene] = useState("home");

  const handleSceneChange = (newScene) => {
    if (newScene !== currentScene) {
      console.log(`UI Scene change: ${currentScene} -> ${newScene}`);
      setCurrentScene(newScene);
    }
  };

  return (
    <div className="relative w-full h-screen bg-black overflow-hidden">
      {/* Project Details Overlay */}
      <ProjectOverlay />
      
      <Canvas
        shadows
        gl={{
          antialias: true,
          alpha: false,
          powerPreference: "high-performance",
        }}
        onCreated={({ gl }) => {
          gl.setClearColor(new THREE.Color(0x000000));
          gl.setPixelRatio(Math.min(window.devicePixelRatio, 2));
        }}
      >
        <PerspectiveCamera makeDefault fov={75} near={0.1} far={1000} />
        <Suspense fallback={null}>
          {/* Keep damping for smooth manual scrolling */}
          <ScrollControls pages={8} damping={0.25}>
            <CurrentTileProvider>
              {/* Always render both scenes but control their visibility */}
              <ParticleText
                ref={particleTextRef}
                visible={currentScene === "home"}
              />

              <ProjectsScene
                disableCameraController={true}
                visible={currentScene === "projects"}
              />

              {/* Unified scroll orchestrator */}
              <UnifiedScrollHandler
                particleTextRef={particleTextRef}
                onSceneChange={handleSceneChange}
              />

              {/* HTML sections (About + Contact) - single Scroll html wrapper */}
              <HTMLSections currentScene={currentScene} />
            </CurrentTileProvider>
          </ScrollControls>
        </Suspense>
      </Canvas>
      
      {/* Project Overlay - rendered outside Canvas but can access context via window events */}
      <ProjectOverlayWrapper />
    </div>
  );
};

// Wrapper component that provides context access outside Canvas
const ProjectOverlayWrapper = () => {
  return (
    <div style={{ position: "fixed", zIndex: 50, pointerEvents: "none" }}>
      <ProjectOverlay />
    </div>
  );
};

export default Unified;
